import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('idea', [
      'isRoleGuest',
      'isRoleBuddy',
      'isRoleOwner',
      'isOwnerSubscribed'
    ]),

    canEdit () {
      return !this.isRoleGuest
    }
  }
}
